export const ModalSizes = Object.freeze({
  ExtraSmall: "xs",
  Small: "sm",
  Medium: "md",
  Large: "lg",
  ExtraLarge: "xl",
});

export const ModalSizeOptions = Object.values(ModalSizes);
